import { render, staticRenderFns } from "./CompanyContactForm.vue?vue&type=template&id=131e6940"
import script from "./CompanyContactForm.vue?vue&type=script&lang=js"
export * from "./CompanyContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports